import React, {useEffect} from "react";
import * as queryString from 'query-string';
import {Container} from "react-bootstrap";
import {UserAuth} from '../model/CustomModel';

declare var window: Window;
const MoveUrlComponent =
    (props: any) => {
        const location = props.location;
        const search = queryString.parse(location.hash);
        //console.log(location.hash);
        useEffect(() => {
            const url = search.url, token = search.token, custNo = search.custNo;
            const theme=search.theme? search.theme.toString():'default';

            sessionStorage.setItem('style',JSON.stringify({theme}));
            if (token) {
                if (typeof token==='string') {
                    const param: UserAuth = {
                        'token': token,
                        'custNo': typeof custNo === 'string' ? custNo : ''
                    };
                    sessionStorage.setItem('userAuth', JSON.stringify(param));
                }
            }
            if (typeof url === "string") {
                window.location.replace(url);
            }


        }, [search]);
        return (
            <Container>
                <div className="text-center text-secondary m-5">페이지 이동중..</div>
            </Container>
        );
    };

export default MoveUrlComponent;
